module.exports = __webpack_public_path__ + "img/f44249254d04551e9bf01bd20f5bc6d8.png";